<template>
  <!-- <van-popup
    v-model:show="show"
    :close-on-click-overlay="false"
    class="loading-popup"
    ><img src="../assets/images/animation_loading_00@3x.png" alt="loading"
  /></van-popup> -->
  <div class="loading_mask">
    <div class="loading-popup">
      <img src="../assets/images/animation_loading_00@3x.png" alt="loading" />
    </div>
  </div>
</template>

<script>
import { Popup } from "vant";
import { toRefs } from "vue";

export default {
  name: "Loading",
  components: {
    [Popup.name]: Popup,
  },
  setup(props) {
    const { show } = toRefs(props);
    console.log("=======show", show);
    return {
      show,
    };
  },
};
</script>

<style lang="less">
.loading_mask {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  z-index: 2006;
  .loading-popup {
    background: rgba(0, 0, 0, 0.3);
    padding: 8px;
    border-radius: 12px;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 40px;
      height: 40px;
      vertical-align: middle;
      animation: load 1.4s ease infinite;
    }
  }
}
// .loading-popup {
//   background: rgba(0, 0, 0, 0.3);
//   padding: 8px;
//   border-radius: 12px;
//   width: 44px;
//   height: 44px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   img {
//     width: 40px;
//     height: 40px;
//     vertical-align: middle;
//     animation: load 1.4s ease infinite;
//   }
// }

@keyframes load {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
